// Pop-ups vidéo de la fiche produit (snippet ax-video-modal) : lecture à l'ouverture,
// arrêt à la fermeture. Les événements dialog:* de Stretch ne remontent pas : on les
// écoute en capture sur document, ce qui couvre aussi les pop-ups réinsérées quand une
// section se recharge au changement de variante.
// Le snippet est rendu une fois par pop-up : le garde évite d'écouter en double.
if (!window.axProductVideoModal) {
  window.axProductVideoModal = true;

  const isVideoModal = (target) => target.classList?.contains('product-video__modal');

  // after-show et non before-show : la pop-up est déplacée dans <body> entre les deux,
  // et déplacer une <video> dans le DOM met sa lecture en pause.
  document.addEventListener('dialog:after-show', ({ target }) => {
    if (!isVideoModal(target)) return;

    target.querySelector('.product-video__video')?.play().catch(() => {});

    const iframe = target.querySelector('.product-video__iframe');
    if (iframe && !iframe.getAttribute('src')) iframe.setAttribute('src', iframe.dataset.ytSrc);
  }, true);

  document.addEventListener('dialog:before-hide', ({ target }) => {
    if (!isVideoModal(target)) return;

    target.querySelectorAll('.product-video__video').forEach((video) => {
      video.pause();
      video.currentTime = 0;
    });

    // Retirer le src coupe la lecture YouTube.
    target.querySelector('.product-video__iframe')?.removeAttribute('src');
  }, true);
}
